import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=77980c65&scoped=true&"
import script from "./BindPhone.vue?vue&type=script&lang=js&"
export * from "./BindPhone.vue?vue&type=script&lang=js&"
import style0 from "./BindPhone.vue?vue&type=style&index=0&id=77980c65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77980c65",
  null
  
)

component.options.__file = "BindPhone.vue"
export default component.exports